import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
import { handleLocalStorage } from '@/assets/js/utils';
export default {
  data() {
    return {
      receiverNotSupportVoIP: false,
      vocalTract: 'left',
      inputVolume: 100,
      duckVolume: 100,
      autoDuck: false,
      showClose: true,
      receiverInfo: {
        show: false,
        title: 'common.switchReceiverSource',
        save: 'kioskHost.yes',
        cancel: 'start.cancel',
        info: {}
      },
      visiable: false,
      sourceList: [],
      showTitle: true,
      loadingS: false,
      selectDeviceType: this.getInitialDeviceType(),
      sourceTypeArray: [{
        label: 'receiver',
        value: 'receiver'
      }, {
        label: 'pack',
        value: 'pack'
      }, {
        label: 'producer',
        value: 'producer'
      }, {
        label: 'channel',
        value: 'channel'
      }],
      packStatus: 'online',
      // 用来查询 pack online 的数据还是 pack recover 的数据
      packStatusArray: {
        pack: [{
          label: 'all',
          value: 'all'
        }, {
          label: 'online',
          value: 'online'
        }, {
          label: 'offline',
          value: 'offline'
        }, {
          label: 'recover',
          value: 'recover'
        }],
        receiver: [{
          label: 'all',
          value: 'all'
        }, {
          label: 'online',
          value: 'online'
        }, {
          label: 'offline',
          value: 'offline'
        }],
        producer: [{
          label: 'online',
          value: 'online'
        }],
        channel: [{
          label: 'online',
          value: 'online'
        }]
      },
      scrollS: {
        onScroll: this.getNextListPage
      },
      sourceListParams: {
        online: true,
        offline: true,
        living: true,
        condition: '',
        pageNum: 1,
        pageSize: 50,
        origin: ''
      },
      packStatusParams: {
        pageNum: 1,
        pageSize: 20,
        partyCode: '',
        autoRecovery: 1
      },
      packHwNames: '',
      selectSourceType: '',
      selectAudioChannel: '',
      receiverAudioChannel: {},
      receiverJoinType: 'stations',
      receiverJoinModule: ['talent', 'stations'],
      receiverSourceType: [],
      vocalTractType: ['left', 'right'],
      hasNextPage: false,
      encoderInfo: {},
      pageMap: {
        pack: '/partyline-backend/pack/page',
        receiver: '/partyline-backend/receiver/v2/page',
        producer: '/partyline-backend/receiver/v3/page',
        channel: '/partyline-backend/receiver/v3/page',
        mediaHub: ''
      },
      pgmNameInfo: {},
      titleMap: {
        pack: 'tvuoneSettingTitle',
        receiver: 'receiverSettingTitle',
        producer: 'producerSettingTitle',
        channel: 'channelSettingTitle'
      },
      selectDevicePeerId: '',
      switchInfo: {
        show: false,
        title: 'addTvuOne.switchPackSource',
        save: 'kioskHost.yes',
        cancel: 'start.cancel',
        info: {},
        key: 'add'
      },
      removeAutoRecoverArray: [],
      selectDeviceInfo: {},
      voipInfo: [],
      // 用来记录 voip 信息
      hasSelectedNumber: 0,
      hasClickNext: false,
      multiJoin: false,
      mediaHubJoin: false,
      canUseVoIP: true,
      notSupportVoIP: false,
      vbrVal: false,
      notSupportVoIPTips: '',
      switchPackTips: ''
    };
  },
  props: {
    rtilCodeList: {
      type: Array,
      default: () => []
    },
    drawer: {
      type: Boolean,
      default: false
    },
    partyCode: {
      type: [Number, String],
      default: ''
    },
    userInfo: {
      type: Object,
      default: () => {}
    },
    mediaHubMemberIds: {
      type: Object,
      default: () => {}
    },
    channels: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    if (this.Config.urlInfo) {
      this.pageMap.mediaHub = `${this.Config.urlInfo.mediaHubServiceUrl}/media-hub/source/sourceListFromSearch`;
    }
    this.hasClickNext = false;
    this.sourceListParams.condition = this.State.searchDeviceInfo.condition;
    this.showTitle = this.State.searchDeviceInfo.showDeviceTitle;
    this.getSourceList('');
    this.getPackVersion();
    if (this.$route.name.includes('intercom')) this.sourceTypeArray = this.sourceTypeArray.slice(0, 2);
    if (this.$route.name == 'party') {
      this.sourceTypeArray.push({
        label: 'mediaHub',
        value: 'mediaHub'
      });
    }
  },
  computed: {
    ...mapState({
      Config: state => state.config,
      State: state => state,
      partyJoinInfo: state => state.partyJoinInfo
    }),
    returnDefaultText() {
      if (this.selectDeviceType === 'pack' || this.selectDeviceType === 'receiver' || this.selectDeviceType === 'mediaHub') {
        return !this.sourceList.length && this.sourceListParams.condition ? this.$t('remainWords.noResults') : this.$t('remainWords.noDevices');
      } else {
        return !this.sourceList.length && this.sourceListParams.condition ? this.$t('remainWords.noResults') : this.$t('remainWords.noRunning');
      }
    },
    returnSaveOrAddBtnText() {
      let _str = '';
      if (this.packStatus === 'recover') {
        _str = this.$t('addTvuOne.remove');
      } else if ((this.partyJoinInfo.channelMode == 1 || this.partyJoinInfo.channelMode == 0) && (this.selectDeviceType === 'receiver' && this.multiJoin || this.selectDeviceType === 'mediaHub' && this.mediaHubJoin)) {
        _str = this.$t('addTvuOne.adding');
      } else {
        _str = this.$t('addTvuOne.adds');
      }
      return _str;
    },
    returnShowAddBtn() {
      if (this.selectDeviceType === 'receiver' || this.selectDeviceType === 'pack') {
        return this.hasClickNext;
      } else {
        return true;
      }
    },
    returnShowFoot() {
      let showFoot = false;
      this.hasSelectedNumber = 0;
      this.sourceList.forEach(item => {
        if (item.hadSelected) {
          showFoot = true;
          this.hasSelectedNumber++;
        }
      });
      if ((this.selectDeviceType === 'producer' || this.selectDeviceType === 'channel' || this.selectDeviceType === 'mediaHub') && this.selectDevicePeerId) {
        showFoot = true;
      }
      return showFoot;
    }
  },
  watch: {
    drawer: {
      immediate: true,
      handler(val) {
        this.visiable = val;
      }
    },
    selectDevicePeerId(val) {
      if (val && (this.selectDeviceType === 'producer' || this.selectDeviceType === 'channel')) {
        const info = this.sourceList.filter(item => (item.peerId || item.receiverId || item.pid) == this.selectDevicePeerId).map(item => item);
        this.getInfoByPeerId(this.selectDevicePeerId, info);
      }
    },
    sourceList: {
      deep: true,
      immediate: true,
      handler(val) {
        this.$nextTick(() => {
          val.forEach((item, index) => {
            const textSpan = this.$refs['textSpan' + index];
            if (textSpan && textSpan[0]) {
              const isOverflow = textSpan[0].scrollWidth > textSpan[0].clientWidth;
              this.$set(item, 'isOverflow', isOverflow);
            }
          });
        });
        if (this.packStatus !== 'recover') return;
        this.removeAutoRecoverArray = [];
        this.sourceList.forEach(item => {
          if (item.hadSelected) {
            this.removeAutoRecoverArray.push(item);
          }
        });
      }
    },
    'switchInfo.show': {
      handler(val) {
        if (val) {
          if (this.selectDeviceType != 'pack') {
            this.switchPackTips = '';
            return;
          }
          const selectArray = this.sourceList.filter(item => {
            return item.hadSelected && item.partyCodes.length && !item.partyCodes.includes(this.partyCode);
          });
          let _str = '';
          selectArray.forEach((item, index) => {
            _str += (item.name || item.sourceName || item.channelName) + this.$t('addTvuOne.inThe') + item.partyCodes[0];
            if (index !== selectArray.length - 1) {
              _str += ',';
            }
          });
          this.switchPackTips = _str;
        }
      }
    }
  },
  methods: {
    getTooltipContent(item) {
      const isPackOrReceiverOrMH = this.selectDeviceType === 'pack' || this.selectDeviceType === 'receiver' || this.selectDeviceType === 'mediaHub';
      if (item.isOverflow && isPackOrReceiverOrMH) {
        return `name: ${item.name || item.sourceName || item.channelName || item.objectName}<br>id: ${item.peerId || item.receiverId || item.pid || item.objectId}`;
      } else {
        return this.showDeviceId(item);
      }
    },
    getInitialDeviceType() {
      const storedType = handleLocalStorage('get', 'selectedDeviceType');
      if (this.$route.name == 'party') {
        return storedType || 'receiver';
      }
      if (storedType === 'mediaHub') {
        return 'receiver';
      }
      return storedType || 'receiver';
    },
    changeVolumeInputValue(value) {
      this.inputVolume = value;
    },
    changeVolume(value) {
      value = Number(value);
      this.duckVolume = value;
      if (value > 100) {
        this.$message.error(this.$t('setting.minVolumeMessage'));
      }
    },
    selectVocalTract() {
      console.log(11);
    },
    async getInfoByPeerId(peerId, item) {
      this.loadingS = true;
      this.encoderInfo = [];
      try {
        await this.getEncoderSource(peerId, item[0]);
        this.getEncoderInfo(peerId);
      } catch (e) {
        this.loadingS = false;
        console.log(e);
      }
    },
    getEncoderInfo(val) {
      this.loadingS = true;
      this.axios.get(`/partyline-backend/receiver/encoder?rid=${val}`).then(res => {
        if (res.data.errorCode === '0x0') {
          if (!res) return;
          this.loadingS = false;
          // 只需要当前会议的 encoder 信息
          const result = res.data.result;
          const currentParty = this.partyCode;
          if (result && result.length) {
            this.encoderInfo = result.filter(item => {
              return item.code == currentParty;
            });
            const lastItem = this.encoderInfo[this.encoderInfo.length - 1];
            if (lastItem) {
              var _lastItem$partyEncode, _lastItem$partyEncode2;
              const tracks = (_lastItem$partyEncode = lastItem.partyEncoder) === null || _lastItem$partyEncode === void 0 ? void 0 : (_lastItem$partyEncode2 = _lastItem$partyEncode.Audio) === null || _lastItem$partyEncode2 === void 0 ? void 0 : _lastItem$partyEncode2.Tracks[0];
              this.selectAudioChannel = tracks;
            } else {
              this.selectAudioChannel = 1;
            }
          } else {
            this.selectAudioChannel = 1;
          }
          if (this.$route.name === 'intercom') {
            this.selectSourceType = 'noVideo';
            this.selectAudioChannel = 'voip';
          }
        }
      }).catch(e => {
        this.loadingS = false;
        console.log(e);
      });
    },
    getSourceList(getNextPage) {
      const url = this.pageMap[this.selectDeviceType];
      const isSelectPackOrReceiver = this.selectDeviceType === 'pack' || this.selectDeviceType === 'receiver' || this.selectDeviceType === 'mediaHub';
      if (!this.showTitle && !this.sourceListParams.condition && isSelectPackOrReceiver) {
        this.sourceList = [];
        return;
      }
      // if (this.loadingS) return
      this.loadingS = true;
      if (this.selectDeviceType === 'channel' || this.selectDeviceType === 'producer') {
        this.sourceListParams.origin = this.selectDeviceType === 'channel' ? this.selectDeviceType : undefined;
        this.sourceListParams.queryCollaborate = true;
      } else if (this.selectDeviceType === 'mediaHub') {
        this.sourceListParams.orderItem = {
          key: 'liveFirst',
          desc: true
        };
      } else {
        this.sourceListParams.origin = undefined;
        this.sourceListParams.queryCollaborate = undefined;
      }
      if (!this.showTitle) {
        this.packStatus = 'all';
      }
      if (isSelectPackOrReceiver) this.dealPackReceiverParamsStatus();
      // mediaHub 移除状态参数
      if (this.selectDeviceType === 'mediaHub') {
        const {
          online,
          offline,
          living,
          ...rest
        } = this.sourceListParams;
        rest.pageSize = 20;
        this.sourceListParams = rest;
      }
      this.axios.post(url, this.sourceListParams).then(res => {
        this.loadingS = false;
        if (res.data.errorCode === '0x0') {
          let result = [];
          if (this.selectDeviceType === 'pack') {
            var _res$data$result;
            result = ((_res$data$result = res.data.result) === null || _res$data$result === void 0 ? void 0 : _res$data$result.list) || [];
          } else if (this.selectDeviceType === 'receiver') {
            var _res$data$result2;
            result = ((_res$data$result2 = res.data.result) === null || _res$data$result2 === void 0 ? void 0 : _res$data$result2.cc.list) || [];
          } else if (this.selectDeviceType === 'channel') {
            var _res$data$result3;
            result = ((_res$data$result3 = res.data.result) === null || _res$data$result3 === void 0 ? void 0 : _res$data$result3.channel) || [];
          } else if (this.selectDeviceType === 'mediaHub') {
            var _res$data$result4;
            result = ((_res$data$result4 = res.data.result) === null || _res$data$result4 === void 0 ? void 0 : _res$data$result4.sourceList) || [];
          } else {
            result = this.dealProducerData(res.data.result.pps);
          }
          result.forEach(item => {
            item.hadSelected = false;
          });
          if (getNextPage) {
            if (!isSelectPackOrReceiver && !this.showTitle) {
              this.sourceList = [];
              this.fullSourceList = this.fullSourceList.concat(result);
            } else {
              this.sourceList = this.sourceList.concat(result);
            }
          } else {
            if (!isSelectPackOrReceiver && !this.showTitle) {
              this.sourceList = [];
              this.fullSourceList = result;
            } else {
              this.sourceList = result;
            }
          }
          if (this.selectDeviceType === 'pack') {
            this.hasNextPage = res.data.result.hasNextPage;
          } else if (this.selectDeviceType === 'receiver') {
            this.hasNextPage = res.data.result.cc.hasNextPage;
          }
        } else {
          this.$message({
            type: 'error',
            message: res.data.result.errorInfo
          });
        }
      }).catch(e => {
        this.loadingS = false;
        console.log(e);
      });
    },
    showTips(item) {
      var _item$partyInfo, _item$partyInfo2;
      return this.$t('addTvuOne.deviceHadJoin', {
        partyList: ((_item$partyInfo = item.partyInfo) === null || _item$partyInfo === void 0 ? void 0 : _item$partyInfo.title) || ((_item$partyInfo2 = item.partyInfo) === null || _item$partyInfo2 === void 0 ? void 0 : _item$partyInfo2.realPartyCode)
      });
    },
    videoRadioDisabled(type) {
      if (this.userInfo.channelMode == '1') {
        if (type === 'noVideo') {
          return true;
        } else {
          if (type === 'SDIIN') {
            return this.selectDeviceInfo.status == '3';
          } else {
            return false;
          }
        }
      } else {
        if (this.selectDeviceType === 'pack') {
          if (type === 'SDIIN') {
            return this.$route.name.includes('intercom') ? true : this.selectDeviceInfo.status == '3';
            // return this.selectDeviceInfo.status == '3'
          } else {
            return !this.canUseVoIP;
          }
        } else {
          return this.$route.name.includes('intercom') ? type !== 'noVideo' : false;
          // return false
        }
      }
    },

    audioRadioDisabled(type) {
      if (this.selectDeviceType === 'pack') {
        if (this.selectSourceType === 'SDIIN') {
          if (this.selectDeviceInfo.status == '3') {
            return true;
          } else {
            return type === 'voip' || type === 'noAudio';
          }
        } else {
          return type !== 'voip' || type === 'voip' && this.notSupportVoIP;
        }
      } else if (this.selectDeviceType === 'receiver') {
        if (this.selectSourceType === 'noVideo') {
          if (type == 'voip' && !this.receiverNotSupportVoIP) {
            return false;
          } else {
            return true;
          }
        } else {
          return type === 'voip' || type === 'noAudio';
        }
      }
    },
    dealPackReceiverParamsStatus() {
      if (this.packStatus === 'all') {
        this.sourceListParams.online = true;
        this.sourceListParams.offline = true;
        this.sourceListParams.living = true;
      } else if (this.packStatus === 'online') {
        this.sourceListParams.online = true;
        this.sourceListParams.offline = false;
        this.sourceListParams.living = true;
      } else if (this.packStatus === 'offline') {
        this.sourceListParams.online = false;
        this.sourceListParams.offline = true;
        this.sourceListParams.living = false;
      }
    },
    dealProducerData(result) {
      const array = [];
      result.forEach(item => {
        const list = item.pageInfo.list;
        list.forEach(receiverItem => {
          const obj = Object.assign({}, item.user, receiverItem);
          array.push(obj);
        });
      });
      return array;
    },
    getSourceListByFilter(key) {
      this.selectDevicePeerId = '';
      this.packStatusParams.pageNum = 1;
      this.sourceListParams.pageNum = 1;
      if (this.selectDeviceType === 'pack') {
        if (key === 'all' || key === 'online' || key === 'offline') {
          this.getSourceList();
        } else {
          this.sourceList = [];
          this.getRecoverList();
        }
      } else if (this.selectDeviceType === 'receiver') {
        this.getSourceList();
      }
    },
    getRecoverList(getNextPage) {
      this.packStatusParams.partyCode = this.partyCode;
      this.axios.post('/partyline-backend/pack/pageRecovery', this.packStatusParams).then(res => {
        this.loadingS = false;
        if (res.data.errorCode === '0x0') {
          const result = res.data.result.list;
          if (getNextPage) {
            this.sourceList = this.sourceList.concat(result);
          } else {
            this.sourceList = result;
          }
          this.hasNextPage = result.hasNextPage;
        } else {
          this.$message({
            type: 'error',
            message: res.data.result.errorInfo
          });
        }
      }).catch(e => {
        this.loadingS = false;
        console.log(e);
      });
    },
    showDeviceId(item) {
      const isPackOrReceiver = this.selectDeviceType === 'pack' || this.selectDeviceType === 'receiver' || this.selectDeviceType == 'mediaHub';
      return isPackOrReceiver ? 'id: ' + (item.peerId || item.objectId) : this.$t('commonFunction.Owner') + ': ' + item.email;
    },
    needShowGrayClass(item) {
      let flag = false;
      if (this.selectDeviceType == 'pack') {
        if (this.packStatus == 'all' || this.packStatus == 'online') {
          flag = item.status == 0 || !item.buildSupport;
        } else if (this.packStatus == 'offline') {
          flag = true;
        }
      } else if (this.selectDeviceType === 'receiver' && !Number(item.status)) {
        flag = true;
      }
      return flag;
    },
    changeSelectType(type) {
      // if (this.loadingS) {
      //   this.$message.warning(this.$t('common.waitingResult'))
      //   return
      // }
      // 存储到localStorage
      handleLocalStorage('set', 'selectedDeviceType', type);
      this.sourceList = [];
      this.hasNextPage = false;
      this.selectDevicePeerId = '';
      this.packStatus = 'online';
      this.sourceListParams = {
        online: true,
        offline: true,
        living: true,
        condition: '',
        pageNum: 1,
        pageSize: 50
      };
      this.packStatusParams = {
        pageNum: 1,
        pageSize: 20,
        partyCode: '',
        autoRecovery: 1
      };
      if (type !== 'pack') {
        this.sourceListParams.offline = false;
        if (type !== 'receiver') {
          this.sourceListParams.living = false;
        }
      }
      this.getSourceList();
    },
    saveSelectDeviceInfo(item) {
      this.selectDeviceInfo = item;
    },
    getPackVoipInfo(items) {
      this.voipInfo = [];
      this.axios.get(`/partyline-backend/pack/rtilVoIP/${items.peerId}`, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          this.canUseVoIP = true;
          this.notSupportVoIP = false;
          const result = res.data.result;
          result && result.forEach(item => {
            this.voipInfo.push(item.partyCode + '');
            // 有可能 encoder 没有被停掉但是在 Agora 那边人又不在了，这是就无法清除掉这个 encoder
            if (item.partyCode == this.partyCode && this.channels[item.rtilCode] && this.channels[item.rtilCode].tid) {
              this.canUseVoIP = false;
            }
          });
          if (!this.receiverSourceType.includes('noVideo')) {
            this.receiverSourceType.push('noVideo');
          }
          if (this.voipInfo.includes(this.partyCode)) {
            this.selectSourceType = 'SDIIN';
            this.selectAudioChannel = 1;
          }
          if (this.selectDeviceInfo.status == '3' && this.userInfo.channelMode == 1) {
            this.selectAudioChannel = '';
          }
          if (this.$route.name.includes('intercom')) {
            this.selectSourceType = 'noVideo';
            this.selectAudioChannel = 'voip';
          }
        } else {
          this.canUseVoIP = false;
          this.notSupportVoIP = true;
          const versionMap = this.Config.supportedPackRtilVoipVersionsMap;
          const hwName = this.selectDeviceInfo.hwName;
          const build = this.selectDeviceInfo.build;
          let supportedBuild = '';
          if (versionMap) {
            for (const key in versionMap) {
              if (versionMap[key].hwName === hwName) {
                supportedBuild = versionMap[key].supportedBuild;
              }
            }
          }
          this.notSupportVoIPTips = this.$t('addTvuOne.deviceVersion', {
            hwName,
            build,
            supportedBuild
          });
          this.receiverSourceType = this.receiverSourceType.filter(item => item !== 'noVideo');
          if (this.selectAudioChannel == 'voip') this.selectAudioChannel = '';
          this.$message.error(res.data.errorInfo);
        }
      }).catch(e => {
        this.canUseVoIP = false;
        this.notSupportVoIP = true;
        console.log(e);
      });
    },
    getReceverVoipInfo(item) {
      this.voipInfo = [];
      this.receiverNotSupportVoIP = false;
      this.axios.get(`/partyline-backend/receiver/rtilVoIP/${item.peerId}`, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          result && result.forEach(item => {
            this.voipInfo.push(item.ChannelId);
          });
        } else if (res.data.errorCode == '82201002') {
          this.receiverNotSupportVoIP = true;
        }
      }).catch(e => {
        this.hasClickNext = false;
        console.log(e);
      });
    },
    showNoTipsCheckBox(item) {
      let flag = false;
      if (this.selectDeviceType === 'pack') {
        if (this.packStatus === 'all' || this.packStatus === 'online') {
          flag = item.status != 0 && item.buildSupport;
        }
      } else if (this.selectDeviceType !== 'producer' && this.selectDeviceType !== 'channel' && this.selectDeviceType != 'mediaHub') {
        flag = true;
      }
      return flag;
    },
    showTipsCheckBox(item) {
      let flag = false;
      if (this.selectDeviceType === 'pack' && this.packStatus !== 'recover') {
        if (this.packStatus === 'all' || this.packStatus === 'online') {
          flag = item.status == 0 || !item.buildSupport;
        } else if (this.packStatus === 'offline') {
          flag = true;
        }
      }
      return flag;
    },
    showNoTips(key, item) {
      if (key === 'notshow' && this.packStatus == 'recover') return true;
      if (!item.partyCodes) return false;
      if (key === 'notshow') {
        return this.selectDeviceType == 'pack' && (item.status == 1 || item.status == 2) && item.buildSupport && !item.partyCodes.length;
      } else {
        return this.selectDeviceType == 'pack' && (item.status == 0 || (item.status == 1 || item.status == 2) && (!item.buildSupport || item.partyCodes.length));
      }
    },
    showDeviceTips(item) {
      let _str = '';
      if (item.status == 0) {
        _str = this.$t('addTvuOne.deviceOffline');
      } else if (!item.buildSupport) {
        _str = this.$t('addTvuOne.deviceVersion', {
          hwName: item.hwName,
          build: item.build,
          supportedBuild: item.supportedBuild
        });
      } else if (item.partyCodes.length) {
        _str = this.$t('addTvuOne.deviceInParty', {
          partyCode: item.partyCodes[0]
        });
      }
      return _str;
    },
    returnCheckBoxDisabled(item) {
      if (this.selectDeviceType === 'pack') {
        return item.status == 0 || !item.buildSupport || !!item.partyCodes.length && !item.partyCodes.includes(Number(this.partyCode));
      } else {
        return false;
      }
    },
    searchSourceList() {
      if (this.selectDeviceType === 'pack' || this.selectDeviceType === 'receiver' || this.selectDeviceType === 'mediaHub') {
        this.sourceListParams.pageNum = 1;
        this.packStatusParams.pageNum = 1;
        this.getSourceList('');
      } else {
        if (!this.sourceListParams.condition) {
          // 如果搜索条件为空，则显示所有数据
          this.sourceList = [];
        } else {
          const lowerCaseCondition = this.sourceListParams.condition.toLowerCase();
          // 使用includes, toLowerCase等方法对fullSourceList进行过滤，根据实际字段调整
          this.sourceList = this.fullSourceList.filter(item => item.name && item.name.toLowerCase().includes(lowerCaseCondition) || item.channelName && item.channelName.toLowerCase().includes(lowerCaseCondition));
        }
      }
    },
    close() {
      if (!this.showTitle) {
        this.packStatus = 'online';
        this.showClose = true;
        this.sourceListParams.pageNum = 1;
        this.packStatusParams.pageNum = 1;
        this.State.searchDeviceInfo.showDeviceTitle = this.showTitle = true;
        this.State.searchDeviceInfo.condition = this.sourceListParams.condition = '';
        this.getSourceList();
      } else {
        this.packStatus = 'all';
        this.encoderInfo = [];
        this.$emit('close');
      }
    },
    getNextListPage() {
      if (!this.loadingS && this.hasNextPage) {
        if (this.packStatus == 'recover') {
          this.packStatusParams.pageNum += 1;
          this.getSourceListByFilter('getNextPage');
        } else {
          this.sourceListParams.pageNum += 1;
          this.getSourceList('getNextPage');
        }
      }
    },
    clickNext() {
      this.hasClickNext = true;
      let array = JSON.parse(JSON.stringify(this.sourceList));
      array = [array.find(item => item.hadSelected)];
      this.selectDeviceInfo = array[0];
      if (this.selectDeviceType === 'pack') {
        this.receiverSourceType = this.receiverSourceType.concat(['SDIIN', 'noVideo']);
        this.receiverAudioChannel.SDIIN = 1;
        this.receiverAudioChannel.noVideo = 1;
        if (this.selectDeviceInfo.status == '3' && this.userInfo.channelMode == 0) {
          this.selectSourceType = 'noVideo';
          this.selectAudioChannel = 'voip';
        } else {
          this.selectSourceType = 'SDIIN';
          this.selectAudioChannel = 1;
        }
        this.getPackVoipInfo(array[0]);
      } else {
        this.getInfoByPeerId(array[0].peerId, array[0]);
        this.getReceverVoipInfo(array[0]);
      }
    },
    saveOperation(key) {
      if (this.selectDeviceType === 'pack') {
        if (this.selectDeviceInfo.status == '3' && this.selectSourceType != 'noVideo') return;
        this.sendPackJoinParty(key);
      } else {
        const isNeedPopAlert = this.judgeSelectSourceType();
        if (isNeedPopAlert) {
          this.receiverInfo.show = true;
        } else {
          this.sendReceiverJoinParty();
        }
      }
      this.State.searchDeviceInfo.condition = this.sourceListParams.condition;
      this.State.searchDeviceInfo.showDeviceTitle = this.showTitle;
    },
    async getEncoderSource(peerId, info) {
      this.receiverSourceType = [];
      const url = this.selectDeviceType === 'receiver' || this.selectDeviceType === 'channel' ? `/${peerId}` : `/${peerId}?productionId=${info.id}`;
      await this.axios.get(`/partyline-backend/receiver/getEncoderSourcesV2${url}`).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result || [];
          this.pgmNameInfo = {};
          result.forEach(item => {
            if (this.selectDeviceType === 'receiver') {
              this.receiverSourceType.push(item.name);
              this.receiverAudioChannel[item.name] = item.audioChannelCount / 2;
            } else if (this.selectDeviceType === 'producer') {
              if (item.name == 'PGM') {
                this.pgmNameInfo.PGM = 'PGM';
                this.receiverAudioChannel[item.name] = item.audioChannelCount / 2;
                this.receiverAudioChannel['PGM (mix minus)'] = item.audioChannelCount / 2;
              } else if (item.name != 'PVW') {
                const key = item.slotNo ? item.slotNo : item.name;
                this.pgmNameInfo[key] = item.name;
                this.receiverSourceType.push(key);
                this.receiverAudioChannel[key] = item.audioChannelCount / 2;
              }
            } else if (this.selectDeviceType === 'channel' && item.name === 'RtilChannelPGM') {
              this.receiverSourceType.push(item.name);
              this.receiverAudioChannel[item.name] = item.audioChannelCount / 2;
            }
          });
          if (this.selectDeviceType === 'receiver') {
            this.receiverSourceType.push('noVideo');
            this.receiverAudioChannel.noVideo = 4;
          }
          if (this.selectDeviceType === 'producer' && this.receiverSourceType.length) {
            this.receiverSourceType = this.receiverSourceType.sort((item1, item2) => {
              if (Number(item1.slice(1)) < Number(item2.slice(1))) {
                return -1;
              } else if (Number(item1.slice(1)) == Number(item2.slice(1))) {
                return 0;
              } else {
                return 1;
              }
            });
            this.receiverSourceType = ['PGM (mix minus)', 'PGM', 'Encoder', ...this.receiverSourceType];
            this.selectSourceType = this.receiverSourceType[0];
          }
          this.selectSourceType = this.receiverSourceType[0];
        } else {
          this.loadingS = false;
        }
      }).catch(e => {
        this.loadingS = false;
        console.log(e);
      });
    },
    dealDefaultValue(val) {
      if (this.selectDeviceType === 'pack') {
        if (val === 'SDIIN') {
          this.selectAudioChannel = 1;
        } else {
          this.selectAudioChannel = 'voip';
        }
      } else if (this.selectDeviceType === 'receiver') {
        if (val === 'noVideo') {
          this.selectAudioChannel = 'voip';
        } else {
          this.selectAudioChannel = 1;
        }
      }
    },
    returnLabel(name) {
      if (!name) return;
      let _str = '';
      if (this.selectDeviceType === 'producer') {
        if (name !== 'PGM (mix minus)' && name !== 'PGM') {
          _str = name.replace('s', 'Slot');
        } else {
          _str = name;
        }
      } else if (this.selectDeviceType === 'channel') {
        if (name === 'RtilChannelPGM') {
          _str = 'Channel Output';
        } else {
          _str = name;
        }
      } else {
        if (name === 'SDIIN') {
          _str = 'SDI IN/HDMI IN';
        } else if (name === 'noVideo') {
          _str = 'No Video';
        } else {
          _str = name == 'Default' ? 'Live Source' : name;
        }
      }
      return _str;
    },
    gobackLastOperation() {
      this.hasClickNext = false;
      this.canUseVoIP = true;
      this.selectSourceType = '';
      this.selectAudioChannel = '';
      this.selectDevicePeerId = '';
      this.selectDeviceInfo = {};
      this.encoderInfo = [];
      this.receiverAudioChannel = {};
      this.receiverSourceType = [];
      if (this.selectDeviceType === 'receiver' || this.selectDeviceType === 'pack') {
        this.sourceList.forEach(item => {
          item.hadSelected = false;
        });
      }
    },
    switchPackJoinParty() {
      const params = {
        peerId: this.selectDeviceInfo.peerId,
        partyCode: this.switchInfo.info.partyCodes[0]
      };
      this.axios.post('/partyline-backend/commonParty/packLeave?origin=occupePack', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.switchInfo.show = false;
          this.switchInfo.info = {};
          this.sendPackJoinParty(this.switchInfo.key, 'notNeedJudge');
        }
      });
    },
    sendPackJoinParty(key, notNeedJudge) {
      var _this$selectDeviceInf, _this$selectDeviceInf2;
      if (this.selectSourceType === 'noVideo') {
        if (key === 'autoAdd') return;
        this.joinPartyByVoIP();
        return;
      }
      if (((_this$selectDeviceInf = this.selectDeviceInfo) === null || _this$selectDeviceInf === void 0 ? void 0 : (_this$selectDeviceInf2 = _this$selectDeviceInf.partyInfo) === null || _this$selectDeviceInf2 === void 0 ? void 0 : _this$selectDeviceInf2.code) == this.partyCode && this.channels[this.selectDeviceInfo.rtilCode] && this.channels[this.selectDeviceInfo.rtilCode].tid) {
        this.$message({
          type: 'warning',
          message: this.$t('addTvuOne.hasAlreadyJoin')
        });
        return;
      }
      // 需要判断是否加入过其他 party
      if (!notNeedJudge) {
        const info = this.sourceList.filter(item => {
          return item.hadSelected && item.partyCodes.length && !item.partyCodes.includes(Number(this.partyCode));
        });
        if (info.length) {
          this.switchInfo.show = true;
          this.switchInfo.info = info[0];
          this.switchInfo.key = key;
          return;
        }
      }
      let array = JSON.parse(JSON.stringify(this.sourceList));
      array = array.filter(item => item.hadSelected).map(item => {
        const nickName = this.returnNameByDeviceType('', item, 'userItem');
        return {
          partyCode: this.partyCode,
          peerId: item.peerId,
          autoRecovery: key === 'autoAdd' ? 1 : 0,
          nickName
        };
      });
      const url = this.userInfo.channelMode == 0 ? '/partyline-backend/commonParty/batch/packJoin' : '/partyline-backend/group/batch/packJoin';
      this.axios.post(url, array, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode == '82201411') {
          const result = res.data.errorResult;
          if (!result) return;
          const htmlString = result.map(item => this.$t('commonFunction.addDeviceFailed', {
            deviceName: item.nickName,
            reason: item.errorMessage
          })).join('<br>');
          this.$message({
            type: 'error',
            dangerouslyUseHTMLString: true,
            message: htmlString
          });
          this.getSourceList();
        } else if (res.data.errorCode != '0x0') {
          this.$message.error(res.data.errorInfo);
        }
        this.$emit('close');
      });
    },
    joinPartyByVoIP() {
      let array = JSON.parse(JSON.stringify(this.sourceList));
      array = array.filter(item => item.hadSelected).map(item => {
        const nickName = this.returnNameByDeviceType('voip', item, 'userItem');
        if (this.$route.name.includes('intercom')) {
          return {
            partyCode: this.partyCode,
            peerId: item.peerId,
            nickName,
            type: item.type,
            sessionType: this.receiverJoinType
          };
        } else {
          return {
            partyCode: this.partyCode,
            peerId: item.peerId,
            nickName,
            audioCaptureMode: this.autoDuck ? 1 : 0,
            duckAudioChannel: this.vocalTract == 'left' ? 0 : 1,
            duckLevelVolume: this.duckVolume,
            type: item.type
          };
        }
      });
      const url = this.$route.name.includes('intercom') ? '/partyline-backend/intercomPro/batch/addDeviceRtilVoIP' : '/partyline-backend/commonParty/batch/addDeviceRtilVoIP';
      this.axios.post(url, array, {
        errorTip: false
      }).then(res => {
        this.$emit('close');
        if (res.data.errorCode === '82201412') {
          const result = res.data.errorResult;
          const htmlString = result.map(item => this.$t('commonFunction.addDeviceFailed', {
            deviceName: item.nickName,
            reason: item.errorMessage
          })).join('<br>');
          this.$message({
            type: 'error',
            dangerouslyUseHTMLString: true,
            message: htmlString
          });
        } else if (res.data.errorCode === '82201409') {
          const result = res.data.errorResult;
          const htmlString = result.map(item => this.$t('common.repeatVoipJoined', {
            deviceId: item.receiverId,
            nickName: item.nickName
          })).join('<br>');
          this.$message({
            type: 'error',
            dangerouslyUseHTMLString: true,
            message: htmlString
          });
        } else if (res.data.errorCode !== '0x0') {
          const result = res.data.errorResult;
          if (!result) return;
          const htmlString = result.map(item => this.$t('commonFunction.addDeviceFailed', {
            deviceName: item.nickName,
            reason: item.errorMessage
          })).join('<br>');
          this.$message({
            type: 'error',
            dangerouslyUseHTMLString: true,
            message: htmlString
          });
        }
      }).catch(e => {
        console.log(e);
      });
    },
    returnAudioInput(item) {
      if (this.selectDeviceType === 'pack') {
        return 'SDI IN/HDMI IN';
      } else {
        return this.$t('audioChannels.stereo') + ' ' + item;
      }
    },
    judgeSelectSourceType() {
      let falg = false;
      if (this.encoderInfo.length) {
        this.encoderInfo.forEach(item => {
          const partyEncoder = item.partyEncoder;
          if (partyEncoder.SharedMemoryName === this.selectSourceType && item.code != this.partyCode) {
            falg = true;
          }
        });
      }
      return falg;
    },
    cancelAdd() {
      this.receiverInfo.show = false;
    },
    cancelSwitch() {
      this.switchInfo.show = false;
      this.switchInfo.info = {};
    },
    returnNameByDeviceType(voip, item, userItem) {
      let nickName;
      if (JSON.stringify(this.selectDeviceInfo) != '{}') {
        if (voip) {
          nickName = userItem ? item.name + '_voip' : this.selectDeviceInfo.name + '_voip';
        } else {
          switch (this.selectDeviceType) {
            case 'pack':
              nickName = userItem ? item.name + '_' + this.selectSourceType : this.selectDeviceInfo.name + '_' + this.selectSourceType;
              break;
            case 'receiver':
              nickName = userItem ? item.name + '_' + this.selectSourceType + `_${this.selectAudioChannel}` : this.selectDeviceInfo.name + '_' + this.selectSourceType;
              break;
            case 'producer':
              nickName = this.selectDeviceInfo.name + '_' + this.selectSourceType;
              break;
            case 'channel':
              nickName = this.selectDeviceInfo.channelName + '_' + (this.selectSourceType === 'RtilChannelPGM' ? 'Channel Output' : this.selectSourceType);
              break;
          }
        }
      } else {
        if (voip) {
          nickName = item.name + '_voip';
        } else {
          switch (this.selectDeviceType) {
            case 'pack':
              nickName = item.name + '_' + this.selectSourceType;
              break;
            case 'receiver':
              nickName = (this.userInfo.channelMode == 1 || this.userInfo.channelMode == 0) && this.selectDeviceType === 'receiver' ? item.name + '_' + this.selectSourceType + `_${this.selectAudioChannel}` : item.name + '_' + this.selectSourceType;
              break;
            case 'producer':
              nickName = item.name + '_' + this.selectSourceType;
              break;
            case 'channel':
              nickName = item.channelName + '_' + (this.selectSourceType === 'RtilChannelPGM' ? 'Channel Output' : this.selectSourceType);
              break;
          }
        }
      }
      return nickName;
    },
    sendReceiverJoinParty() {
      // mediaHub类型暂时没有添加selectAudioChannel
      if ((!this.selectSourceType || !this.selectAudioChannel) && this.selectDeviceType != 'mediaHub') return;
      if (this.selectSourceType === 'noVideo') {
        this.joinPartyByVoIP();
        return;
      }
      if (this.selectDeviceType === 'receiver') {
        this.saveMultiRJoin();
        return;
      }
      let params;
      let url;
      if (this.selectDeviceType != 'mediaHub') {
        const nickName = this.returnNameByDeviceType();
        // 需要添加mediaHub start preview 相关params
        params = [{
          receiverId: this.selectDevicePeerId,
          partyCode: this.partyCode,
          source: this.selectSourceType,
          trackIds: [this.selectAudioChannel],
          replace: true,
          nickName
        }];
        // 判断是否已经添加过了
        const hasAdd = this.judgeHasJoinParty();
        if (hasAdd) {
          this.$confirm(this.$t('addTvuOne.confrimRestart'), this.$t('partyInfo.rejoin'), {
            confirmButtonText: this.$t('Movepips.done'),
            cancelButtonText: this.$t('Movepips.cancel'),
            type: 'warning'
          }).then(() => {
            const url = this.userInfo.channelMode == 0 ? '/partyline-backend/commonParty/batch/receiverJoinAsParticipant' : '/partyline-backend/group/batch/receiverJoinAsParticipant';
            this.axios.post(url, params).then(res => {
              if (res.data.errorCode === '0x0') {
                this.$emit('close');
              }
            });
          }).catch(() => {});
          return;
        }
        // 需要对 producer 做特殊处理
        if (this.selectDeviceType === 'producer') {
          if (this.selectSourceType === 'PGM (mix minus)') {
            params[0].source = 'RTILPGM';
          } else if (this.selectSourceType === 'PGM') {
            params[0].source = 'PGM';
          } else if (this.selectSourceType === 'Encoder') {
            params[0].source = 'StudioOutput';
          } else {
            params[0].source = this.pgmNameInfo[this.selectSourceType];
          }
        }

        // 需要对 Gallery 单独处理
        if ((this.userInfo.channelMode == 1 || this.userInfo.channelMode == 0) && this.selectDeviceType === 'receiver') {
          params[0].replace = false;
        }
        url = this.userInfo.channelMode == 0 ? '/partyline-backend/commonParty/batch/receiverJoinAsParticipant' : '/partyline-backend/group/batch/receiverJoinAsParticipant';
      } else {
        var _boxPoolAttr$attrValu;
        if (this.mediaHubJoin) return;
        params = {
          objectId: this.selectDevicePeerId,
          partyCode: this.partyCode,
          nickName: this.selectDeviceInfo.objectName
        };
        // 动态添加agentBoxPoolId参数
        const boxPoolAttr = (this.selectDeviceInfo.attributes || []).find(attr => attr.attrName === 'boxPoolId');
        if (boxPoolAttr && ((_boxPoolAttr$attrValu = boxPoolAttr.attrValue) === null || _boxPoolAttr$attrValu === void 0 ? void 0 : _boxPoolAttr$attrValu.length) > 0) {
          params.agentBoxPoolId = boxPoolAttr.attrValue[0];
        }
        url = '/partyline-backend/commonParty/startMediaHubPreview';
        const hasAdd = this.mediaHubMemberIds && Object.values(this.mediaHubMemberIds).some(value => value.includes(params.objectId));
        const keys = this.mediaHubMemberIds ? Object.keys(this.mediaHubMemberIds).map(String) : [];
        const rtilArray = Array.isArray(this.rtilCodeList) ? this.rtilCodeList.map(String) : [];
        const isExit = keys.length === rtilArray.length && keys.every((key, index) => key === rtilArray[index]);
        if (hasAdd && isExit) {
          this.$message({
            type: 'warning',
            message: this.$t('addTvuOne.hasAlreadyJoin')
          });
          return;
        } else if (hasAdd && !isExit) {
          this.$message({
            type: 'warning',
            message: this.$t('addTvuOne.removing')
          });
          return;
        }
        this.mediaHubJoin = true;
      }
      this.axios.post(url, params, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode != '0x0') {
          this.$message({
            type: 'error',
            message: res.data.errorInfo
          });
        } else {
          this.$emit('close');
        }
        if (this.selectDeviceType === 'mediaHub') {
          this.mediaHubJoin = false;
        }
      }).catch(e => {
        this.mediaHubJoin = false;
      });
    },
    judgeHasJoinParty() {
      let flag = false;
      this.encoderInfo.forEach(item => {
        var _partyEncoder$Audio, _partyEncoder$Audio$T;
        const {
          code,
          partyEncoder
        } = item;
        if (code == this.partyCode && partyEncoder.SharedMemoryName == this.selectSourceType && (_partyEncoder$Audio = partyEncoder.Audio) !== null && _partyEncoder$Audio !== void 0 && (_partyEncoder$Audio$T = _partyEncoder$Audio.Tracks) !== null && _partyEncoder$Audio$T !== void 0 && _partyEncoder$Audio$T.includes(this.selectAudioChannel)) {
          flag = true;
        }
      });
      return flag;
    },
    saveMultiRJoin() {
      this.multiJoin = true;
      const selectArray = this.sourceList.filter(item => item.hadSelected);
      const params = [];
      selectArray.forEach(item => {
        const obj = {
          receiverId: item.peerId,
          partyCode: this.partyCode,
          source: this.selectSourceType,
          trackIds: [this.selectAudioChannel],
          replace: false,
          nickName: this.returnNameByDeviceType('', item, 'userItem'),
          networkSelect: this.vbrVal ? 'vbr' : ''
        };
        params.push(obj);
      });
      const url = this.userInfo.channelMode == 0 ? '/partyline-backend/commonParty/batch/receiverJoinAsParticipant' : '/partyline-backend/group/batch/receiverJoinAsParticipant';
      this.axios.post(url, params, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode !== '0x0') {
          const result = res.data.errorResult;
          if (!result) return;
          const htmlString = result.map(item => this.$t('commonFunction.addDeviceFailed', {
            deviceName: item.nickName,
            reason: item.errorMessage
          })).join('<br>');
          this.$message({
            type: 'error',
            dangerouslyUseHTMLString: true,
            message: htmlString
          });
        } else {
          this.$emit('close');
        }
        this.multiJoin = false;
      }).catch(e => {
        this.multiJoin = false;
      });
    },
    getPackVersion() {
      // 过滤出 supportedBuild 大于等于 0 的项,才能正常加入party
      const filteredItems = Object.entries(this.Config.supportedPackVersionsMap).filter(([key, value]) => value.supportedBuild >= 0);
      const result = filteredItems.map(([key, value]) => `${value.hwName}: ${value.supportedBuild}+`);
      this.packHwNames = result.join(', ');
    },
    cancelAutoRecover() {
      const array = this.sourceList.filter(item => item.hadSelected).map(item => item.id);
      const params = {
        ids: array,
        partyCode: this.partyCode
      };
      this.axios.post('/partyline-backend/pack/batchRemoveAutoRecovery', params).then(res => {
        this.loadingS = false;
        if (res.data.errorCode === '0x0') {
          this.getRecoverList();
        }
      });
    }
  }
};